// Admin 主布局:左侧 Sidebar + 主区 children
// 跟 web 的 AppLayout 共用 globals.css 的 .app-shell / .app-main 样式
//
// Suspense 边界放在主区内部(而不是 App.tsx 包整个 Routes):
// 这样点左侧菜单跳 lazy 页面时,只有右侧内容区显示"加载中",侧栏保持不动,
// 不再整页闪。
import type { ReactNode } from 'react'
import { Suspense } from 'react'
import { AdminSidebar } from './AdminSidebar.js'

export function AdminLayout({ children }: { children: ReactNode }): JSX.Element {
  return (
    <div className="app-shell">
      <AdminSidebar />
      <main className="app-main">
        <Suspense fallback={<div style={{ padding: 48, textAlign: 'center' }}>加载中…</div>}>
          {children}
        </Suspense>
      </main>
    </div>
  )
}
